"use strict";
/**
 * Base types for AngularJS component controller.
 *
 * @packageDocumentation
 * @module Base
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
//#endregion
//#region Util Imports
var jquery_1 = tslib_1.__importDefault(require("jquery"));
var lodash_es_1 = require("lodash-es");
/**
 * Base Angular controller for components.
 * Should be used to standardize the way component controllers are implemented and how their content is loaded.
 */
var IMRBaseComponentController = /** @class */ (function () {
    function IMRBaseComponentController() {
    }
    //#endregion
    //#region ng.IComponentController Implementation
    IMRBaseComponentController.prototype.$onChanges = function (changes) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isOptionsDefined(changes)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.initialize(this.options)];
                    case 1:
                        _a.sent();
                        this.onInitialized();
                        _a.label = 2;
                    case 2:
                        this.bindingChanged(changes);
                        return [2 /*return*/];
                }
            });
        });
    };
    IMRBaseComponentController.prototype.$onDestroy = function () {
        this.destroy();
        this.onDisposed();
    };
    IMRBaseComponentController.prototype.callEvent = function (action, args) {
        if (lodash_es_1.isFunction(action)) {
            var eventArgs = lodash_es_1.assign(args, {
                component: this,
            });
            return action(eventArgs);
        }
    };
    /**
     * Hooks up into the given options onInitialized function and returns a promise, that resolves when the onInitialized function is called.
     *
     * @returns A promise that resolves with the first argument passed to onInitialized
     */
    IMRBaseComponentController.prototype.waitForOnInitialized = function (options) {
        var innerDeffered = jquery_1.default.Deferred();
        if (options != null) {
            var onInitializedOrg_1 = options.onInitialized;
            options.onInitialized = function (e) {
                if (lodash_es_1.isFunction(onInitializedOrg_1)) {
                    onInitializedOrg_1(e);
                }
                innerDeffered.resolve(e);
            };
        }
        else {
            innerDeffered.reject();
        }
        return innerDeffered.promise();
    };
    IMRBaseComponentController.prototype.onDisposed = function () {
        if (this.options != null && this.options.onDisposed != null) {
            this.options.onDisposed();
        }
    };
    IMRBaseComponentController.prototype.onInitialized = function () {
        if (this.options != null && this.options.onInitialized != null) {
            this.options.onInitialized({
                component: this,
            });
        }
    };
    /**
     * Called when one of the bindings has changed.
     */
    // tslint:disable-next-line:no-empty
    IMRBaseComponentController.prototype.bindingChanged = function (changes) { };
    /**
     * Called when Angular removes this component.
     * The onDisposed event is fired after this function has returned.
     */
    // tslint:disable-next-line:no-empty
    IMRBaseComponentController.prototype.destroy = function () { };
    //#endregion
    //#region Utils
    IMRBaseComponentController.prototype.isOptionsDefined = function (changes) {
        var optionsChanges = changes['options'];
        return (optionsChanges != null &&
            optionsChanges.currentValue != null &&
            optionsChanges.isFirstChange);
    };
    return IMRBaseComponentController;
}());
exports.IMRBaseComponentController = IMRBaseComponentController;
//# sourceMappingURL=base.controller.js.map